import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { MagneticNorthNotifier } from './magnetic-north-notifier';
import { MagneticNorthState } from './magnetic-north-state';

@Injectable()
export class MagneticNorthProvider extends BaseProvider<MagneticNorthNotifier, MagneticNorthState> {
  constructor() {
    super(MagneticNorthNotifier);
  }
}
